import { BookablePersonType } from '@sales-app/types/BookablePersonType'
import { gql } from 'graphql-request'

export namespace FollowUpQueries {
  export namespace GET {
    export type Response = { followUpTasks: FollowUpTask[] | null }
  }
  export function getFollowUpTasks() {
    return gql`
      query getFollowUpTasks($filter: FollowUpTaskFilter) {
        followUpTasks(filter: $filter) {
          id
          notes
          dueDate
          followUpTaskTypeId
          followUpTaskType
          followUpTaskStatus
          completedAt
          cancelledAt
        }
      }
    `
  }
}

export interface FollowUpTask {
  bookablePersonId: number | null
  bookablePersonType: BookablePersonType | null
  cancelledAt: string | null
  completedAt: string | null
  dueDate: string | null
  followUpTaskStatus: string
  followUpTaskType: string
  followUpTaskTypeId: number
  id: number
  notes: string | null
  potentialBookingId: number | null
}

export interface FollowUpTaskRow extends FollowUpTask {
  formattedDueDate: Date | null
  status: string
}
